import { render, staticRenderFns } from "./BackPostDoubleTrebleCrochetIcon.vue?vue&type=template&id=7647652b&scoped=true"
import script from "./BackPostDoubleTrebleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./BackPostDoubleTrebleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./BackPostDoubleTrebleCrochetIcon.vue?vue&type=style&index=0&id=7647652b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647652b",
  null
  
)

export default component.exports